import { useState } from "react";
import axios from "axios";
import { UserPlus, X, Loader2 } from "lucide-react";
import { API } from "./constants";

export const ProjectTeam = ({ projectId, teamMembers, onRefresh }) => {
  const [name, setName] = useState("");
  const [role, setRole] = useState("member");
  const [adding, setAdding] = useState(false);

  const addMember = async () => {
    if (!name.trim() || adding) return;
    setAdding(true);
    try {
      await axios.post(`${API}/projects/${projectId}/team`, { name: name.trim(), role }, { withCredentials: true });
      setName("");
      setRole("member");
      onRefresh();
    } catch (e) { console.error(e); }
    finally { setAdding(false); }
  };

  const removeMember = async (memberId) => {
    try {
      await axios.delete(`${API}/projects/${projectId}/team/${memberId}`, { withCredentials: true });
      onRefresh();
    } catch (e) { console.error(e); }
  };

  return (
    <div className="p-6" data-testid="team-tab">
      <div className="flex items-center gap-2 bg-white border border-border/50 rounded-xl px-4 py-2.5 mb-4">
        <UserPlus className="w-4 h-4 text-foreground/45" />
        <input value={name} onChange={e => setName(e.target.value)}
          placeholder="Add team member..." className="flex-1 text-sm outline-none bg-transparent placeholder:text-foreground/45"
          onKeyDown={e => e.key === "Enter" && addMember()} data-testid="new-member-input" />
        <select value={role} onChange={e => setRole(e.target.value)} className="text-[10px] border border-border/40 rounded-lg px-2 py-1 outline-none text-foreground/50" data-testid="member-role-select">
          <option value="member">Member</option>
          <option value="reviewer">Reviewer</option>
          <option value="editor">Editor</option>
          <option value="admin">Admin</option>
        </select>
        <button onClick={addMember} disabled={!name.trim() || adding} className="text-xs font-semibold px-3 py-1.5 rounded-lg bg-[#014d7d] text-white disabled:opacity-30" data-testid="add-member-btn">
          {adding ? <Loader2 className="w-3 h-3 animate-spin" /> : "Add"}
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {teamMembers?.map((m, i) => (
          <div key={m.user_id || i} className="bg-white border border-border/50 rounded-xl p-4 flex items-center gap-3 group" data-testid={`team-member-${m.user_id || i}`}>
            <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ background: m.color }}>{m.initials}</div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground truncate">{m.name}</p>
              <p className="text-[10px] text-foreground/50 capitalize">{m.role}</p>
            </div>
            {i > 0 && m.user_id && (
              <button onClick={() => removeMember(m.user_id)}
                className="w-6 h-6 rounded-lg hover:bg-red-50 flex items-center justify-center text-foreground/15 hover:text-red-500 opacity-0 group-hover:opacity-100"
                data-testid={`remove-member-${m.user_id}`} title="Remove member">
                <X className="w-3 h-3" />
              </button>
            )}
          </div>
        ))}
      </div>
      {teamMembers.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No team members assigned</p>}
    </div>
  );
};
